if (!customElements.get('th-results-marquee')) {
  customElements.define('th-results-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.button = this.querySelector('.th-rm__toggle');
      this.button.addEventListener('click', () => this.pause(!this.hasAttribute('data-paused')), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.toggleAttribute('data-visible', entries[0].isIntersecting);
      }, { rootMargin: '100px' });
      this.observer.observe(this);
      this.addEventListener('shopify:block:select', event => {
        this.pause(true);
        event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
      }, { signal });
    }
    pause(paused) {
      this.toggleAttribute('data-paused', paused);
      this.button.setAttribute('aria-pressed', String(paused));
      this.button.textContent = paused ? this.button.dataset.play : this.button.dataset.pause;
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
